module.exports = __webpack_public_path__ + "img/gb.d87f3776.svg";